import { TEST } from "../actions/types";
import testReducer from "../reducers/test";

import { removeBrokenLogics, validateLogics } from "../utills/logicUtils";
import { removeBrokenQuotas, verifyQuotaIntegrity } from "../utills/quotaUtils";

export const ScreenerValidationMiddleware = (store) => (next) => (action) => {
  if (action.type !== TEST.UPDATE_SCREENER) return next(action);

  // avoid recursion when we dispatch fix/rollback
  if (action.meta?.skipValidation) return next(action);

  const showScreener = JSON.parse(localStorage.getItem("showScreener") || "false");
  if (!showScreener) return next(action);

  const prevScreener = structuredClone(store.getState().test.screener);

  // simulate next state (pre-reducer)
  const nextTestState = testReducer(store.getState().test, action);
  const data = nextTestState?.screener?.data;

  // If no questions, nothing to validate
  const questions = data?.questions || [];
  if (!questions.length) return next(action);

  // ---- Validate logic ----
  const logicValidationMap = validateLogics(questions);
  const logicValid = Object.values(logicValidationMap).every((i) => i.isValid);

  // ---- Validate quotas (only if quotas exist) ----
  const quotas = data?.quotas?.quota || [];
  let quotaValidationMap = null;
  let quotaValid = true;

  if (quotas.length) {
    quotaValidationMap = verifyQuotaIntegrity(questions, quotas);
    quotaValid = Object.values(quotaValidationMap).every((i) => i.isValid);
  }

  // If all valid, let reducer + other middleware run
  if (logicValid && quotaValid) return next(action);

  const confirmationFor =
    !logicValid && !quotaValid
      ? TEST.CONFIRMATION_FOR.TASK_LOGIC_AND_QUOTA
      : !logicValid
        ? TEST.CONFIRMATION_FOR.TASK_LOGIC
        : !quotaValid
          ? TEST.CONFIRMATION_FOR.SCREENER_QUOTA
          : null;

  // Block update and show modal once
  store.dispatch({
    type: TEST.SHOW_UPDATE_CONFIRMATION_MODAL,
    payload: {
      confirmationFor,
      show: true,
      errorMessage: { logicValidationMap, quotaValidationMap },

      onProceed: () => {
        let updatedQuestions = questions;
        let updatedQuotas = quotas;

        if (!logicValid) {
          updatedQuestions = removeBrokenLogics(logicValidationMap, questions);
        }

        // if logic changes, quotas may become invalid. Re-check quotas against updatedQuestions.
        if (quotas.length) {
          const qMap = verifyQuotaIntegrity(updatedQuestions, quotas);
          const qValid = Object.values(qMap).every((i) => i.isValid);
          if (!qValid) {
            updatedQuotas = removeBrokenQuotas(qMap, quotas);
          }
        }

        store.dispatch({
          type: TEST.UPDATE_SCREENER,
          meta: { skipValidation: true },
          payload: {
            data: {
              ...data,
              questions: updatedQuestions,
              quotas: data?.quotas ? { ...data.quotas, quota: updatedQuotas } : data?.quotas,
            },
          },
        });
      },

      onCancel: () => {
        store.dispatch({
          type: TEST.UPDATE_SCREENER,
          meta: { skipValidation: true },
          payload: prevScreener,
        });
      },
    },
  });

  // stop original update (since invalid)
  return;
};
